export default {
  'Watermark': 'العلامة المائية',
  'Add Watermark Selection': 'إضافة تحديد العلامة المائية',
}